import { InjectionToken } from "@angular/core";

export const LG_APP_GET_PERIOD_NAME = new InjectionToken<
    (version: any, showDataVersionPeriode: boolean) => string
>("lgAppGetPeriodName");
